module.exports = __webpack_public_path__ + "static/fast-carousel-basic-835f3746d329813d85eaa96ee3d154e7.png";